import React, { useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CardDndContext from './CardDndContext';

export default function SortableCard({ id, isOpen, onToggle, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : undefined,
    position: 'relative',
    zIndex: isDragging ? 10 : undefined,
  };

  const ctx = useMemo(() => ({
    dragHandleProps: { ...attributes, ...listeners },
    isOpen,
    onToggle,
  }), [attributes, listeners, isOpen, onToggle]);

  return (
    <div ref={setNodeRef} style={style}>
      <CardDndContext.Provider value={ctx}>
        {children}
      </CardDndContext.Provider>
    </div>
  );
}
